import React from 'react'
import { Image, List, Icon, Button, Popup, Checkbox, Input } from 'semantic-ui-react';
import { debounce } from "lodash";
import { dispatch } from '@rematch/core';
import aciveFilterIcon from './../../../../../images/grafix-icon/icon-check-circle.svg';


// const services = [
//     { text: 'Playbook', value: 'practices' },
//     { text: 'Initiative', value: 'initiatives' },
//     { text: 'Content', value: 'contents' },
//     { text: 'Community', value: 'suborganizations' },
// ];

class StreamHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            limit: 10,
            btn: true,
            changeOrder: -1,
            filterActive: false,
            serviceArray: [
                'practices',
                'initiatives',
                'contents',
                'suborganizations',
                'accounts',
                'organizations'
            ],
            name: "",
            open: false,
            serviceData: [
                { text: 'Playbook', value: 'practices' },
                { text: 'Initiative', value: 'initiatives' },
                { text: 'Content', value: 'contents' },
                { text: 'Community', value: 'suborganizations' },
            ],
            openFilter: false
        };
    }

    openModal = () => {
        this.setState({ openFilter: !this.state.openFilter })
    }

    onChangeHandel = (text) => {
        this.setState({ name: text })
        if (text.length === 0) {
            this.setState({ open: true })
        } else {
            this.setState({ open: false })
        }
        this.searchEvent(text)
    }

    searchEvent = debounce(async (text) => {
        let payload = {
            limit: this.state.limit + 10,
            name: text,
            sortingType: this.state.changeOrder,
            serviceName: this.state.serviceArray,
            type: this.props.filterQuery.type
        }
        await dispatch.notifications.setFilterQueryData(payload)
        if (this.props.type === 'event-stream') {
            dispatch.notifications.getEventStreamByOrganization({})
        } else {
            dispatch.notifications.getNotifications({})
        }

    }, 1000);


    changeSortOrder = (e) => {
        this.setState({ changeOrder: this.state.changeOrder === 1 ? -1 : 1 })

        setTimeout(() => {
            this.changeOrder(e)
        }, 200);

    }


    changeOrder = debounce(async (e) => {
        let payload = {
            limit: this.state.limit + 10,
            name: this.state.name,
            sortingType: this.state.changeOrder,
            serviceName: this.state.serviceArray,
            type: this.props.filterQuery
        }
        await dispatch.notifications.setFilterQueryData(payload)
        if (this.props.type === 'event-stream') {
            dispatch.notifications.getEventStreamByOrganization({})
        } else {
            dispatch.notifications.getNotifications({})
        }
    }, 300)

    addServices(e, data) {
        this.setState({ btn: false })
        let addedIndex = this.state.serviceArray.indexOf(data.name);
        if (addedIndex !== -1) {
            this.setState({ serviceArray: [...this.state.serviceArray.slice(0, addedIndex), ...this.state.serviceArray.slice(addedIndex + 1)] })
        } else {
            this.setState({ serviceArray: [...this.state.serviceArray, data.name] })
        }

    }

    async applyEventFilter(e) {
        this.setState({ filterActive: true, btn: true, openFilter: false })
        let payload = {
            name: this.state.name,
            serviceName: this.state.serviceArray,
            sortingType: this.state.changeOrder,
            type: this.props.filterQuery.type
        }
        await dispatch.notifications.setFilterQueryData(payload)
        if (this.props.type === 'event-stream') {
            dispatch.notifications.getEventStreamByOrganization({})
        } else {
            dispatch.notifications.getNotifications({})
        }
    }

    clearInput = (e, value) => {
        this.setState({ name: '' })
        this.searchEvent(value)
    }

    onFocus = () => {
        if (this.state.name.length === 0) {
            this.setState({ open: true })
        }
    }

    onBlur = () => {
        this.setState({ open: false })
    }

    render() {

        let isFilterActive = this.state.serviceArray.length !== 0 && this.state.serviceArray.length !== this.state.serviceData.length && this.state.filterActive
        return (
            <div style={{ lineHeight: "21px" }}>
                <Popup
                    className="cursor-pointer popupStyled"
                    inverted
                    position="left center"
                    open={this.state.open}
                    hoverable={true}
                    trigger={
                        <form className="float-left pad_5" autoComplete="off" style={{ width: "calc(100% - 73px)" }}>
                            <Input
                                className="w_100 searchEventInput"
                                placeholder='Search...'
                                onChange={(e) => { this.onChangeHandel(e.target.value) }}
                                name="name"
                                value={this.state.name}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                icon={this.state.name ?
                                    <Icon name="close" className="cursor-pointer" onClick={(e) => this.clearInput(e, null)} /> :
                                    <Icon name="search" />
                                }

                            />
                        </form>
                    }
                    content='Search by Team/Playbook/Content/Initiative name'
                />


                <Popup
                    trigger={
                        <div className="float-left pad_5" style={{ margin: "0 5px 0 8px", width: "30px" }}>
                            <Icon
                                name={this.state.changeOrder === 1 ? "sort amount down" : "sort amount up"}
                                onClick={(e) => this.changeSortOrder(e)}
                            />
                        </div>}
                    content={this.state.changeOrder === 1 ? "New to Old" : "Old to New"}
                    className="popupStyled"
                    position="bottom right"
                    style={{ padding: "10px 0" }}
                    inverted
                />

                <div className="float-left" style={{ width: "30px" }}>
                    <Popup
                        on='click'
                        trigger={
                            <div onClick={this.openModal} className={`${isFilterActive ? "activeEventFilter" : "pad_5"}`}>
                                <Icon name="sliders horizontal" />
                                {isFilterActive ?
                                    <Image
                                        src={aciveFilterIcon}
                                        className="pull-right "
                                        style={{ margin: "-10px 0 0 0px", width: '10px', color: 'white' }}
                                    /> : null}
                            </div>
                        }
                        position="bottom right"
                        style={{ padding: "10px 0" }}
                        // open={this.state.openFilter}
                        hideOnScroll
                    >
                        <Popup.Content>
                            <List divided verticalAlign='middle' >
                                <List.Item style={{ padding: "5px 10px" }}>
                                    <List.Content >
                                        <b>Filter</b>
                                    </List.Content>
                                </List.Item>

                                {this.state.serviceData.map((name, i) => {
                                    return <List.Item key={i} style={{ padding: "5px 10px" }}>
                                        <List.Content >
                                            <Checkbox
                                                name={name.value}
                                                label={name.text}
                                                checked={this.state.serviceArray.includes(name.value)}
                                                onChange={(e, data) => this.addServices(e, data)}
                                                disabled={this.state.serviceArray.length === 1 && this.state.serviceArray.includes(name.value)} />
                                        </List.Content>
                                    </List.Item>
                                })}
                                <List.Item style={{ padding: "5px 10px" }}>
                                    <List.Content >
                                        <Button
                                            size="mini"
                                            disabled={this.state.btn}
                                            fluid className="button-submit"
                                            onClick={(e) => this.applyEventFilter(e)}>Apply</Button>
                                    </List.Content>
                                </List.Item>
                            </List>
                        </Popup.Content>
                    </Popup>
                </div>



            </div>
        )
    }
}

export default StreamHeader;